import {
  Article as APIArticle,
  ArticleComment as APIArticleComment,
} from '@sdk/newsfeed/types/apiTypes';
import { AuthUserType } from '@sdk/authentication/types/AuthUserType';
import { PersonaCollection } from '@sdk/personaCollection/types/PersonaCollection';

import { escapeAttachmentUrl } from '@web/common/utils/escapeAttachmentUrl';
import { Article, ArticleComment } from '@web/newsfeed/types/Article';
import { getNewsfeedUser } from '@web/newsfeed/utils/getNewsfeedPersona';

type ArticleMapperProps<T> = {
  article: T;
  currentUser?: AuthUserType;
  personaCollection: PersonaCollection;
};

export const mapAPIArticleToUI = ({
  article,
  currentUser,
  personaCollection,
}: ArticleMapperProps<APIArticle>): Article => {
  const { id, channel, content, commented, comments, liked, likes, posted, user, attachments } =
    article;
  return {
    id,
    page: channel,
    content,
    attachments: escapeAttachmentUrl(attachments),
    commentedByMe: commented,
    commentsCount: comments || 0,
    likedByMe: liked,
    likesCount: likes || 0,
    posted: new Date(posted),
    seenBy: article.seenby,
    user: getNewsfeedUser(user, personaCollection, currentUser),
  };
};

type ArticleCommentMapperProps<T> = {
  comment: T;
  currentUser?: AuthUserType;
  personaCollection: PersonaCollection;
};

export const mapAPIArticleCommentToUI = ({
  comment,
  currentUser,
  personaCollection,
}: ArticleCommentMapperProps<APIArticleComment>): ArticleComment => {
  const { articleId, attachments, channelId, content, id, liked, likes, posted, user } = comment;
  return {
    articleId,
    attachments: escapeAttachmentUrl(attachments),
    pageId: channelId,
    content,
    id,
    isDeleted: false,
    likedByMe: liked,
    likesCount: likes,
    posted: new Date(posted),
    user: getNewsfeedUser(user, personaCollection, currentUser),
  };
};
